'use client';

import { Inter as FontSans } from 'next/font/google';
import { cn } from '@/lib/utils';

import '@/styles/globals.css';
const fontSans = FontSans({
  subsets: ['latin'],
  variable: '--font-sans',
});

const RootLayout = () => {
  const handleGoToAICommercePlatform = () => {
    window.open('https://platform.gotolstoy.com/', '_blank');
  };

  return (
    <html lang="en" className="h-full" suppressHydrationWarning>
      <head>
        <meta name="shopify-debug" content="web-vitals" />
        <link rel="icon" href="/studio-icon.svg" />
        <title>Bunu Studio</title>
      </head>
      <body className={cn('m-0 h-full p-0 font-sans antialiased', fontSans.variable)}>
        <div className="flex h-full flex-col items-center justify-center gap-2">
          <div className="text-center text-2xl font-medium">We’ve moved to The AI Commerce platform.</div>
          <div className="text-center text-sm">
            Supercharge product discovery, engagement, and conversion with AI-first shopping experiences.
          </div>

          <button
            className="mt-2 flex cursor-pointer items-center gap-3 rounded-2xl border-none bg-blue-500 bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 px-4 py-2 font-semibold text-white shadow-lg shadow-purple-500/25 backdrop-blur-sm transition-all duration-300 hover:scale-[1.03] hover:shadow-xl hover:shadow-purple-500/40 hover:brightness-110 active:scale-[0.98]"
            onClick={handleGoToAICommercePlatform}
          >
            Go to the AI Commerce platform
          </button>
        </div>
      </body>
    </html>
  );
};

export default RootLayout;
